<template>
<div id="app">
  <!-- <p style="color: #000;
    font-size: 12px;
    z-index: 1010;
    display: block;
    position: absolute;">{{$store.state.timeSpent}}</p> -->
  <router-view />
</div>
</template>

<script>
import io from 'socket.io-client';
import api from '@/api';
import router from '@/router';

export default {
  data() {
    return {
      socket: null,
    };
  },
  created() {
    this.$root.$on('settingSocket', key => {
      this.setSocket(key);
    });
  },

  mounted() {},

  methods: {
    setSocket(key) {
      this.socket = null;
      this.socket = io('https://terminal-ws.briskly.online');
      this.socket.on('connect', () => {
        this.socket.emit('create', key);
        this.socket.on('message', data => {
          if (typeof data.data.order !== 'undefined') {
            this.$store.state.order = data.data.order;
            this.$store.state.timeSpent = 0;
            window.scrollTo(0, document.body.scrollHeight);
            if (this.$route.fullPath !== '/basket') {
              this.$router.push('/basket');
            }
            this.$store.state.timeSpent = 0;
          } else {
            if (data.data.action === 'error') {
              if(data.data.payload.code === 2006) {
                let elem = this;
                setTimeout(function(){
                  elem.$router.push('/');
                }, 5000);
                this.$alert(data.data.payload.message);
                this.$router.push('/');
              } else {
              //this.$alert(data.data.payload.message);
              }
            }
            if (data.data.action === 'redirect') {
              //console.log(data.data);
              this.$router.push({ name: data.data.payload.route, params: data.data.payload.params });
            } else if (data.data.action === 'redirect_url') {
              this.$router.push(data.data.payload.url);
            } else if (data.data.action === 'message') {
              alert(data.payload.message);
            }
          }
        });
      });
    },
  },
};
</script>
